export default __webpack_public_path__ + "static/media/asset-1.34517887.png";